import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { FileText, CheckCircle, Clock, Edit, XCircle } from 'lucide-react';

interface ArticleStatsOverviewProps {
  totalArticles: number;
  draft: number;
  scheduled: number;
  published: number;
  blocked: number;
}

export default function ArticleStatsOverview({ totalArticles, draft, scheduled, published, blocked }: ArticleStatsOverviewProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mb-8">
      <Card className="border border-slate-200">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-600">Total Articles</p>
              <p className="text-2xl font-bold text-slate-900">{totalArticles}</p>
            </div>
            <div className="h-12 w-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <FileText className="text-blue-600" size={24} />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border border-slate-200">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-600">Draft</p>
              <p className="text-2xl font-bold text-slate-900">{draft}</p>
            </div>
            <div className="h-12 w-12 bg-slate-100 rounded-lg flex items-center justify-center">
              <Edit className="text-slate-600" size={24} />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border border-slate-200">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-600">Scheduled</p>
              <p className="text-2xl font-bold text-slate-900">{scheduled}</p>
            </div>
            <div className="h-12 w-12 bg-amber-100 rounded-lg flex items-center justify-center">
              <Clock className="text-amber-600" size={24} />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border border-slate-200">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-600">Published</p>
              <p className="text-2xl font-bold text-slate-900">{published}</p>
            </div>
            <div className="h-12 w-12 bg-green-100 rounded-lg flex items-center justify-center">
              <CheckCircle className="text-green-600" size={24} />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border border-slate-200">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-600">Blocked</p>
              <p className="text-2xl font-bold text-slate-900">{blocked}</p>
            </div>
            <div className="h-12 w-12 bg-red-100 rounded-lg flex items-center justify-center">
              <XCircle className="text-red-600" size={24} />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}